module.exports = __webpack_public_path__ + "img/ios-share-icon.7d76bb2e.png";